/**
 * A service with common operations related to dates and times
 */
(function(){
  angular.module('core')
    .factory('edxDateTimeService', ['translateFilter', 'moment', '$locale', dateTimeServiceFactory]);

  function dateTimeServiceFactory(translateFilter, moment, $locale) {

    /**
     * Return 3 character abbreviation for the day of the week
     *
     * @param date Date to test
     */
    function dayOfWeekAbbreviated(date) {
      return moment(date).locale($locale.id).format('ddd');
    }

    /**
     * Returns 3 character abbreviation for the day of the week, or "Today" if date is today
     *
     * @param date Date to test
     * @return {string}
     */
    function dayOfWeekOrToday(date) {
      if (isToday(date)) {
        return translateFilter('shared.today');
      } else {
        return dayOfWeekAbbreviated(date);
      }
    }

    /**
     * Determines if a date is "today" per the browsers clock and timezone
     *
     * @param date
     * @return {boolean}
     * @private
     */
    function isToday(date) {
      var today = moment().locale($locale.id).format('Y-MM-DD');
      var actual = moment(date).locale($locale.id).format('Y-MM-DD');
      return today === actual;
    }

    return {
      dayOfWeekAbbreviated: dayOfWeekAbbreviated,
      dayOfWeekOrToday: dayOfWeekOrToday,
      isToday: isToday
    };
  }
})();
